module.exports = __webpack_public_path__ + "images/emoji/mailbox_with_mail.5f8354eb28eaa31577c1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mailbox_with_mail.png
// module id = qHKQ
// module chunks = 13